import { render, staticRenderFns } from "./WBtnPrint.vue?vue&type=template&id=0aabecd9&scoped=true&"
import script from "./WBtnPrint.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnPrint.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabecd9",
  null
  
)

export default component.exports